import { MibpHttpApi, PermissionService, GlobalConfigService, BroadcastService } from 'root/services';
import { DashboardTitlePartscatalogComponent } from './../../../../components/dashboard-title-partscatalog/dashboard-title-partscatalog.component';
import { MibpDashboardMyFleetComponent } from './../dashboard-myfleet/dashboard-myfleet.component';
import { MibpDashboardLatestOrdersComponent } from './../dashboard-latest-orders/dashboard-latest-orders.component';
import { MibpDashboardLatestBulletinsComponent } from './../dashboard-latest-bulletins/dashboard-latest-bulletins.component';
import { Injectable, inject } from '@angular/core';
import { TileItem } from './tile-item';
import { MibpDashboardCreditLimitComponent } from '../dashboard-creditlimit/dashboard-creditlimit.component';
import { DashboardTileQuickaddComponent } from 'root/modules/home/components';
import { MySandvikFeatures } from 'root/services/permission';
import { MibpDashboardMyFeaturesComponent } from '../dashboard-myfeatures/dashboard-myfeatures.component';
import { MibpDashboardEngineHoursComponent } from '../dashboard-engine-hours/dashboard-engine-hours.component';
import { MibpDashboardEngineHoursStatusComponent } from '../dashboard-enginehours-status/dashboard-enginehours-status.component';
import { DasboardTileTypes } from 'root/mibp-openapi-gen/models';
import { ApiErrorHandlerService } from 'root/services/api-error-handler/api-error-handler';
import { firstValueFrom } from 'rxjs';
import { MibpDashboardLatestNewsComponent } from '../dashboard-latest-news/dashboard-latest-news.component';
import { permissionPolicyKey } from 'root/services/permission';
import { usersFnGetCurrentUserDashboardTileSettings } from "root/mibp-openapi-gen/fn/users/users-fn-get-current-user-dashboard-tile-settings";
import { usersFnSaveCurrentUserDashboardTileSettings } from "root/mibp-openapi-gen/fn/users/users-fn-save-current-user-dashboard-tile-settings";
import { MibpApiService } from "root/mibp-openapi-gen/mibp-api.service";

@Injectable()
export class TileService {
    private mibpApiService = inject(MibpApiService);
  private httpService = inject(MibpHttpApi);
  private errorHandler = inject(ApiErrorHandlerService);
  private permissions = inject(PermissionService);
  private globalConfig = inject(GlobalConfigService);
  private broadcast = inject(BroadcastService);


  private canSeeCreditLimit = false;

 
  constructor() {
  }

  private allDefaultTiles : TileItem[] =
    [
      new TileItem(
        {
          component: MibpDashboardLatestNewsComponent,
          tileResourceStringKey: "Dashboard_LatestNews",
          sortOrder: 0,
          type: DasboardTileTypes.Dashboard_News,
          isHeaderApplicable: true,
          accessTestCallback: () => { return this.permissions.test(permissionPolicyKey('canSeeNewsArticles')); },
          tileRedirectLink: "/:lang/news"
        }
      ),
      new TileItem(
        {
          component: MibpDashboardLatestBulletinsComponent,
          tileRedirectLink:  "/:lang/bulletins",
          tileResourceStringKey: "Dashboard_LatestBulletins",
          sortOrder: 1,
          type: DasboardTileTypes.Dashboard_Bulletins,
          accessTestCallback: () => this.permissions.test(permissionPolicyKey('bulletins'))
        }
      ),

      new TileItem({
        component: MibpDashboardMyFleetComponent,
        tileResourceStringKey: "Fleet_Title",
        tileRedirectLink: "/:lang/myfleet/machines",
        sortOrder: 2,
        type: DasboardTileTypes.Dashboard_MyFleet,
        accessTestCallback: () => this.permissions.test(permissionPolicyKey('myfleet'))
      }),

      new TileItem( {
        component: MibpDashboardLatestOrdersComponent,
        tileResourceStringKey:  "Dashboard_LatestOrders",
        tileRedirectLink: "/:lang/shop/orders",
        sortOrder: 3,
        type: DasboardTileTypes.Dashboard_Orders,
        accessTestCallback: () => this.permissions.test(permissionPolicyKey('viewOrdersAndQuotations'))
      }),

      new TileItem(
        {
          component: MibpDashboardCreditLimitComponent,
          tileResourceStringKey: "Dashboard_CreditLimit",
          sortOrder: 4,
          type: DasboardTileTypes.Dashboard_CreditLimit,
          accessTestCallback: () => this.testAccessToCreditLimitTile()
        }
      ),

      new TileItem(
        {
          component: DashboardTileQuickaddComponent,
          tileResourceStringKey: "Quick-Add-Dashboard-BuyDirectly",
          sortOrder: 5,
          type: DasboardTileTypes.Dashboard_QuickAdd,
          accessTestCallback: () => this.permissions.test(permissionPolicyKey('canAddToCart'))
        }
      ),

      new TileItem({
        component: DashboardTitlePartscatalogComponent,
        tileResourceStringKey: "Dashboard_PartsCatalogueTitle",
        tileRedirectLink: "/:lang/myfleet/electronic-manuals",
        sortOrder: 6,
        type: DasboardTileTypes.Dashboard_Partscatalog,
        accessTestCallback: () => this.permissions.test(permissionPolicyKey('canSeeElectronicManuals'))
      }),

      new TileItem({
        component: MibpDashboardMyFeaturesComponent,
        tileResourceStringKey: "Settings_Features_Title",
        sortOrder: 7,
        type: DasboardTileTypes.Dashboard_MyFeatures,
        accessTestCallback: () => this.permissions.test({features: [MySandvikFeatures.GeneralMyFeaturesTile]})
      }),
      //Commented out  until we know how the dashboard tiles should be diplayed.
      // new TileItem({
      //   component: MibpDashboardEngineHoursComponent,
      //   tileResourceStringKey: "Global_MachineEngineHours",
      //   // tileRedirectLink: "/:lang/myfleet/machines",
      //   sortOrder: 8,
      //   type: DasboardTileTypes.Dashboard_MachineEngineHours,
      //   accessTestCallback: () => !this.globalConfig.disableTopEngineHoursTile && this.permissions.test(permissionPolicyKey('myfleet'))
      // }),
      // new TileItem({
      //   component:  MibpDashboardEngineHoursStatusComponent,
      //   tileResourceStringKey: "Global_MachineEngineHoursStatus",
      //   tileRedirectLink: "/:lang/myfleet/machines",
      //   sortOrder: 9,
      //   type: DasboardTileTypes.Dashboard_MachineEngineHoursStatus,
      //   accessTestCallback: () => !this.globalConfig.disableEngineHoursStatusTile && this.permissions.test(permissionPolicyKey('myfleet'))
      // }),

    ];

  private testAccessToCreditLimitTile(): boolean {

    return this.permissions.test({features: [MySandvikFeatures.ShopViewCreditLimit]});

  }


  getUserTileSettings() : Promise<TileItem[]> {

    if (!this.broadcast.snapshot.mibpSession?.user) {
      return Promise.resolve([]);
    }

    const self = this;
    const defaultAllTiles = this.allDefaultTiles;
    return new Promise<TileItem[]>((resolve, reject) => {
      this.mibpApiService.invoke(usersFnGetCurrentUserDashboardTileSettings).subscribe({
        next: items => {
          defaultAllTiles.forEach(function(tile : TileItem){
            const settings = items.find((item) => { return tile.Type == item.dasboardTilesType; });
            if(settings){
              tile.sortOrder = settings.sortOrder;
              tile.isHiddenByUser = settings.isHidden;
            }
          });
          resolve(defaultAllTiles);
        },
        error: e => reject(e)
      });
    });
  }

  saveUserTileSettings(userTileSetting: string) : Promise<unknown> {
    return firstValueFrom(this.mibpApiService.invoke(usersFnSaveCurrentUserDashboardTileSettings, {body: {tilesSettingsString: userTileSetting}}))
      .catch(e => this.errorHandler.parseError(e).showNotice() );
  }
}
